import React, { useEffect } from 'react';
import './GDPRCookieConsent.css';

const GDPRCookieConsent = ({ locale, translations }) => {
  useEffect(() => {
    document.body.classList.add('has-cookie-info-bar');
    return () => document.body.classList.remove('has-cookie-info-bar');
  }, []);
  const getCookieText = () => {
    if (locale === 'de') {
      return {
        message: translations?.cookieConsent?.message || 
          "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern und für Marketingzwecke. Durch die weitere Nutzung dieser Website stimmen Sie unserer Verwendung von Cookies zu.",
        learnMore: translations?.cookieConsent?.learnMore || "Mehr erfahren",
        privacyLink: "/de/datenschutz"
      };
    } else if (locale === 'it') {
      return {
        message: translations?.cookieConsent?.message || 
          "Utilizziamo i cookie per migliorare la tua esperienza e per scopi di marketing. Continuando a utilizzare questo sito web, acconsenti al nostro utilizzo dei cookie.",
        learnMore: translations?.cookieConsent?.learnMore || "Scopri di più",
        privacyLink: "/it/privacy"
      };
    } else if (locale === 'se') {
      return {
        message: translations?.cookieConsent?.message ||
          "Vi använder cookies för att förbättra din upplevelse och för marknadsföringsändamål. Genom att fortsätta använda denna webbplats godkänner du vår användning av cookies.",
        learnMore: translations?.cookieConsent?.learnMore || "Läs mer",
        privacyLink: "/se/integritetspolicy"
      };
    }
    return null;
  };

  const cookieText = getCookieText();

  if (!cookieText) return null;

  return (
    <div className="cookie-info-bar">
      <div className="cookie-consent-content">
        <span className="cookie-message">{cookieText.message}</span>
        <a 
          href={cookieText.privacyLink} 
          className="cookie-privacy-link"
        >
          {cookieText.learnMore}
        </a>
      </div>
    </div>
  );
};

export default GDPRCookieConsent;
